export default {
    path: '/enterprise',
    redirect: '/enterprise/menus',
    meta: {
        title: "企业后台",
        permissionCode: "pcSystem",
        icno: ""
    },
    children: [
        {
            path: 'info',
            name: 'info',
            meta: {
                permissionCode: "pcSystemCompany",
                title: '企业信息',
               
                
            },
            component: () => import("@/views/enterprise/info/index.vue")
        }, 
        {
            path: 'dept',
            name: 'dept',
            meta: {
                permissionCode: "pcSystemDepart",
                title: '部门管理',
               
                
            },
            component: () => import("@/views/enterprise/department/index.vue")
        }, 
        {
            path: 'roles',
            name: 'roles',
            meta: {
                permissionCode: "pcSystemRole",
                title: '角色管理',
               
                
            },
            component: () => import("@/views/enterprise/roles/index.vue")
        }, 
        {
            path: 'staff',
            name: 'staff',
            meta: {
                permissionCode: "pcSystemStaff",
                title: '员工管理',
               
                
            },
            component: () => import("@/views/enterprise/staff/index.vue")
        }, 
        {
            path: 'equipment',
            name: 'equipment',
            meta: {
                permissionCode: "pcSystemEquipment",
                title: '设备管理',
               
                
            },
            component: () => import("@/views/enterprise/equipment/index.vue")
        }, 
        {
            path: 'account',
            name: 'account',
            meta: {
                permissionCode: "pcSystemAccount",
                title: '账号管理',
               
                
            },
            component: () => import("@/views/enterprise/account/index.vue")
        }, 
        {
            path: 'datas',
            name: 'datas',
            meta: {
                permissionCode: "pcSystemData",
                title: '数据管理',
               
                
            },
            component: () => import("@/views/enterprise/datas/index.vue")
        }, 
        {
            path: 'menus',
            name: 'menus',
            meta: {
                permissionCode: "pcSystemMenu",
                title: '菜单管理',
               
                
            },
            component: () => import("@/views/enterprise/menus/index.vue")
        }, 
    ]
}